<template>
  <div class="point-course">
    <ShadowBox class="shadow-box" opacity="_60">
      <div class="point-area">
        <img src="@/assets/point_mark.png" alt="ポイントマーク">
        <span class="point">
          {{ point | comma }}P
          <div class="append_point">ランクボーナス +{{appendPoint | comma}}PT</div>
        </span>

        <!--        <span class="point-service" v-if="bonusPoint > 0">-->
        <!--          {{point | comma}}P + おまけ{{bonusPoint | comma}}P-->
        <!--        </span>-->
      </div>
      <span class="value" :class="{is_discount: (useCoupon && discount < price)}">
        <span class="discount"><span>¥</span>{{ discount | comma }}</span>
        <span class="price"><span>¥</span>{{ price | comma }}</span>
      </span>
      <OrangeGradationButton text="購入する" @handleSquareBtnClick="handleBuyBtnClick" class="gradation" />
      <div class="memo">{{ memo }}</div>
    </ShadowBox>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';

import ShadowBox from '@/components/atoms/ShadowBox.vue';
// import SquareButton from '@/components/atoms/SquareButton.vue';
import OrangeGradationButton from '@/components/atoms/OrangeGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'PointCourse',
  mixins: [t],

  components: {
    ShadowBox,
    // SquareButton,
    OrangeGradationButton,
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },

  props: {
    point: {
      type: Number,
    },
    appendPoint: {
      type: Number,
    },
    price: {
      type: Number,
    },
    discount: {
      type: Number,
    },
    useCoupon: {
      type: Boolean,
    },
    memo: {
      type: String,
    },
  },

  computed: {
    bonusPoint() {
      const bonusPoint = parseInt(this.point, 10) - parseInt(this.price, 10);
      return separateCharacterNumber(bonusPoint);
    },
  },

  methods: {
    handleBuyBtnClick() {
      this.$emit('handleBuyBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.point-course {
  text-align: left;
  width: 50%;

  .shadow-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 10px;
    font-family: $notoSansJP;
    font-size: 20px;
    flex-wrap: wrap;
    background-color: $white;
    border-radius: 6px;

    .point-area {
      display: flex;
      flex-wrap: wrap;

      img {
        width: 29px;
        height: 29px;
        border-radius: 20px;
        margin-right: 10px;
        @media screen and (max-width: $tabletWidth) {
          margin-right: 2px;
        }
      }

      .point {
        font-weight: 700;
        line-height: 29px;
        color: $black;
        // &:before {
        //   content: "P";
        //   width: 30px;
        //   height: 30px;
        //   border-radius: 100px;
        //   background-color: $white;
        //   margin-right: 10px;
        //   color: $deepGray;
        //   display: inline-flex;
        //   justify-content: center;
        //   align-items: center;
        // }
      }

      .point-service {
        font-size: 12px;
      }
    }

    .value {
      margin-left: auto;
      color: $black;
      margin-right: 20px;
      @media screen and (max-width: $tabletWidth) {
        margin-right: 5px;
      }
      .discount {
        display: none;
      }
    }
    .is_discount {
      display: flex;
      flex-direction: column;
      text-align: right;
      .discount {
        display: inline;
        color: $red;
      }
      .price {
        font-size: 12px;
        text-decoration: line-through; /* 取り消し線 */
        text-decoration-color: red; /* 取り消し線の色 */
      }
    }

    .square-button {
      width: 82px;
      height: 36px;
      margin-left: 24px;
    }
  }

  .gradation {
    // background-color: $black;
    color: $white;
  }
}

.memo {
  width: 100%;
  margin-left: 40px;
  font-size: 12px;
  color: $red;
}

.append_point {
  color: #ffc000;
  @media screen and (max-width: $tabletWidth) {
    line-height: 1px;
    font-size: 10px;
  }
}

@media screen and (max-width: $tabletWidth) {
  .point-course {
    width: 100%;

    .shadow-box {
      font-size: 16px;
      padding: 10px 5px;
    }
  }
}
</style>
